<div class="dropdown" style="float:right;">
  <button class="tw-px-3 tw-py-1 tw-rounded-sm" style="background-color: #FCEEC3;">
    <p class="tw-text-sm tw-text-pinkDark">{{currentCity | titlecase}} &nbsp;<fa-icon [icon]="faMapMarkerAlt"></fa-icon></p>
  </button>

  <ul class="dropdown-content" style="width: max-content;">
    <li *ngFor="let city of cities" class="tw-flex tw-items-center" (click)="onCitySelected(city)" >
      <img src="{{city.icon}}" style="width: 30px;" alt="" srcset="">
      &nbsp;&nbsp;
      <p class="tw-text-sm">{{city.name | titlecase}}</p>
    </li>
  </ul>
</div>